import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const error = params.get("error");

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-deep px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl border border-ivory/10 bg-ivory p-10 text-center shadow-2xl">
        <p className="font-serif text-4xl font-semibold text-brand-green">
          OravioCare
        </p>
        <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-sage">Concierge admin</p>

        {error === "unauthorized" && (
          <p className="mt-6 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="admin-login-error">
            That Google account isn't authorized for this dashboard.
          </p>
        )}
        {error === "failed" && (
          <p className="mt-6 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="admin-login-error">
            Sign-in failed. Please try again.
          </p>
        )}

        <button
          data-testid="google-signin-btn"
          onClick={signIn}
          disabled={checking}
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-brand-green px-6 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-brand-glow disabled:opacity-50"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21.35 11.1H12v2.9h5.35c-.5 2.4-2.55 3.9-5.35 3.9a5.9 5.9 0 1 1 0-11.8c1.5 0 2.85.55 3.9 1.45l2.2-2.2A8 8 0 1 0 12 20a8 8 0 0 0 9.35-7.9z" />
          </svg>
          {checking ? "Checking session…" : "Sign in with Google"}
        </button>

        <a href="/" data-testid="admin-login-back-link" className="mt-6 inline-block text-xs font-medium text-sage transition-colors hover:text-brand-green">
          ← Back to oraviocare.com
        </a>
      </div>
    </div>
  );
}
